/**
 * Include your custom JavaScript here.
 *
 * RAPIUS accessibility hardening added below.
 */

(function () {
  var STYLE_ID = 'rapius-accessibility-overrides';

  if (document.getElementById(STYLE_ID)) {
    return;
  }

  var css = '' +
    ':root{--rapius-a11y-focus:#1e2d7d;--rapius-a11y-focus-offset:#ffffff;--rapius-a11y-border:#64748b;--rapius-a11y-link:#0056b3;--rapius-sticky-header-offset:96px;}' +
    'html{scroll-padding-top:var(--rapius-sticky-header-offset);}' +
    '[id]{scroll-margin-top:var(--rapius-sticky-header-offset);}' +
    '.skip-to-content,.visually-hidden.skip-to-content{position:absolute!important;left:.75rem!important;top:-5rem!important;z-index:9999!important;width:auto!important;height:auto!important;padding:.75rem 1rem!important;overflow:visible!important;clip:auto!important;white-space:nowrap!important;color:var(--rapius-a11y-focus)!important;background:#fff!important;border:3px solid var(--rapius-a11y-focus)!important;border-radius:.5rem!important;box-shadow:0 2px 12px rgba(15,23,42,.25)!important;}' +
    '.skip-to-content:focus,.skip-to-content:focus-visible{top:.75rem!important;}' +
    'a:focus-visible,button:focus-visible,input:focus-visible,select:focus-visible,textarea:focus-visible,summary:focus-visible,[role="button"]:focus-visible,[role="link"]:focus-visible,[tabindex]:not([tabindex="-1"]):focus-visible{outline:3px solid var(--rapius-a11y-focus)!important;outline-offset:3px!important;box-shadow:0 0 0 2px var(--rapius-a11y-focus-offset)!important;}' +
    'input,select,textarea,.input,.select,.quantity-selector,.form__field,.field__input{border-color:var(--rapius-a11y-border)!important;}' +
    'input:focus,select:focus,textarea:focus,input:focus-visible,select:focus-visible,textarea:focus-visible{border-color:var(--rapius-a11y-focus)!important;}' +
    '.button--secondary,.button--ternary,.link--bordered,.pagination__nav-item,.quantity-selector__button{border-color:var(--rapius-a11y-border)!important;}' +
    'a:not(.button):not(.product-item__image-wrapper):not(.aspect-ratio){color:var(--rapius-a11y-link);}' +
    '.text--accent,.footer__item a,.footer__aside a{color:var(--rapius-a11y-link);}' +
    '.button,button,[role="button"],input[type="submit"],input[type="button"],.quantity-selector__button,.product-form__add-button,.header__action-item-link,.mobile-menu__nav-link{min-width:44px;min-height:44px;}' +
    '.color-swatch,.block-swatch__item,.product-form__option-name,.product-form__option-value{min-width:32px;min-height:32px;}' +
    '.drawer button:focus-visible,.drawer [role="button"]:focus-visible,.drawer a:focus-visible,.drawer input:focus-visible,.drawer select:focus-visible,.drawer textarea:focus-visible,.modal button:focus-visible,.modal [role="button"]:focus-visible,.modal a:focus-visible,.modal input:focus-visible,.modal select:focus-visible,.modal textarea:focus-visible,[role="dialog"] button:focus-visible,[role="dialog"] [role="button"]:focus-visible,[role="dialog"] a:focus-visible,[role="dialog"] input:focus-visible,[role="dialog"] select:focus-visible,[role="dialog"] textarea:focus-visible{outline:3px solid var(--rapius-a11y-focus)!important;outline-offset:3px!important;box-shadow:0 0 0 2px #fff!important;}' +
    '.form__error,.alert--error,[aria-invalid="true"]{color:#dc2626;}' +
    '[aria-invalid="true"]{border-color:#dc2626!important;}' +
    '@media (prefers-reduced-motion:reduce){*,*::before,*::after{animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition-duration:.01ms!important;}}';

  var style = document.createElement('style');
  style.id = STYLE_ID;
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();

(function () {
  if (window.RapiusVariantGuide) {
    return;
  }

  var CONTROL_SELECTOR = '.product-form__single-selector[data-option-position]';
  var DATA_SELECTOR = 'script[data-rapius-variant-guide]';
  var STATUS_ID = 'rapius-variant-guide-status';
  var pendingFocus = Object.create(null);
  var focusSequence = 0;
  var announcementFrame = 0;

  function normalize(value) {
    return String(value == null ? '' : value).trim().replace(/\s+/g, ' ');
  }

  function controlText(control) {
    if (control.tagName === 'SELECT') {
      var selectedOption = control.options[control.selectedIndex];
      return normalize(selectedOption ? selectedOption.textContent : '');
    }

    var label = control.labels && control.labels[0];

    if (!label) {
      return '';
    }

    return normalize(label.getAttribute('title') || label.textContent);
  }

  function selectedValues(picker) {
    var values = [];
    var controls = picker.querySelectorAll(CONTROL_SELECTOR);

    Array.prototype.forEach.call(controls, function (control) {
      var position = parseInt(control.getAttribute('data-option-position'), 10) - 1;

      if (position < 0) {
        return;
      }

      if (control.tagName === 'SELECT' || control.checked) {
        values[position] = controlText(control);
      }
    });

    return values;
  }

  function findControl(picker, position, value) {
    var controls = picker.querySelectorAll(CONTROL_SELECTOR);
    var expected = normalize(value);

    for (var index = 0; index < controls.length; index += 1) {
      var control = controls[index];

      if (parseInt(control.getAttribute('data-option-position'), 10) !== position + 1) {
        continue;
      }

      if (control.tagName === 'SELECT') {
        for (var optionIndex = 0; optionIndex < control.options.length; optionIndex += 1) {
          if (normalize(control.options[optionIndex].textContent) === expected) {
            return {
              control: control,
              value: control.options[optionIndex].value
            };
          }
        }
      } else if (controlText(control) === expected) {
        return {
          control: control,
          value: control.value
        };
      }
    }

    return null;
  }

  function applyValue(picker, position, value) {
    var match = findControl(picker, position, value);

    if (!match) {
      return false;
    }

    if (match.control.tagName === 'SELECT') {
      match.control.value = match.value;
    } else {
      match.control.checked = true;
    }

    return true;
  }

  function readGuideData(picker) {
    var script = picker.querySelector(DATA_SELECTOR);

    if (!script) {
      return null;
    }

    try {
      var data = JSON.parse(script.textContent);

      if (!data || !Array.isArray(data.variants)) {
        return null;
      }

      return data;
    } catch (error) {
      return null;
    }
  }

  function isExactVariant(variant, values) {
    return variant.options.length === values.length && variant.options.every(function (value, index) {
      return normalize(value) === normalize(values[index]);
    });
  }

  function matchesOptionPrefix(variant, values, position, candidateValue) {
    if (!Array.isArray(variant.options) || variant.options.length <= position) {
      return false;
    }

    for (var optionIndex = 0; optionIndex <= position; optionIndex += 1) {
      var expectedValue = optionIndex === position ? candidateValue : values[optionIndex];

      if (normalize(variant.options[optionIndex]) !== normalize(expectedValue)) {
        return false;
      }
    }

    return true;
  }

  function optionValueState(variants, values, position, candidateValue) {
    var matchingVariants = variants.filter(function (variant) {
      return matchesOptionPrefix(variant, values, position, candidateValue);
    });

    if (!matchingVariants.length) {
      return 'impossible';
    }

    if (!matchingVariants.some(function (variant) {
      return variant.available !== false;
    })) {
      return 'sold-out';
    }

    return '';
  }

  function updateVariantStates(picker) {
    var data = readGuideData(picker);

    if (!data) {
      return;
    }

    var values = selectedValues(picker);
    var controls = picker.querySelectorAll(CONTROL_SELECTOR);

    Array.prototype.forEach.call(controls, function (control) {
      var position = parseInt(control.getAttribute('data-option-position'), 10) - 1;

      if (position < 0) {
        return;
      }

      if (control.tagName === 'SELECT') {
        Array.prototype.forEach.call(control.options, function (option) {
          var state = option.disabled ? optionValueState(data.variants, values, position, option.textContent) : '';

          if (state) {
            option.setAttribute('data-rapius-variant-state', state);
          } else {
            option.removeAttribute('data-rapius-variant-state');
          }
        });

        return;
      }

      var wrapper = control.closest('.block-swatch');

      if (!wrapper) {
        return;
      }

      var state = control.disabled ? optionValueState(data.variants, values, position, controlText(control)) : '';
      wrapper.classList.toggle('block-swatch--rapius-impossible', state === 'impossible');
      wrapper.classList.toggle('block-swatch--rapius-sold-out', state === 'sold-out');
    });
  }

  function updateAllVariantStates() {
    var pickers = document.querySelectorAll('variant-picker');
    Array.prototype.forEach.call(pickers, updateVariantStates);
  }

  function selectBestVariant(variants, currentValues, clickedPosition, clickedValue) {
    var candidates = [];

    variants.forEach(function (variant, variantIndex) {
      if (variant.available === false || !Array.isArray(variant.options) || normalize(variant.options[clickedPosition]) !== normalize(clickedValue)) {
        return;
      }

      var retained = [];
      var retainedCount = 0;

      variant.options.forEach(function (value, optionIndex) {
        var isRetained = optionIndex !== clickedPosition && normalize(value) === normalize(currentValues[optionIndex]);
        retained[optionIndex] = isRetained ? 1 : 0;

        if (isRetained) {
          retainedCount += 1;
        }
      });

      candidates.push({
        variant: variant,
        variantIndex: variantIndex,
        retained: retained,
        retainedCount: retainedCount
      });
    });

    candidates.sort(function (left, right) {
      if (left.retainedCount !== right.retainedCount) {
        return right.retainedCount - left.retainedCount;
      }

      var optionCount = Math.max(left.retained.length, right.retained.length);

      for (var optionIndex = 0; optionIndex < optionCount; optionIndex += 1) {
        if (optionIndex === clickedPosition) {
          continue;
        }

        var leftRetained = left.retained[optionIndex] || 0;
        var rightRetained = right.retained[optionIndex] || 0;

        if (leftRetained !== rightRetained) {
          return rightRetained - leftRetained;
        }
      }

      return left.variantIndex - right.variantIndex;
    });

    return candidates.length ? candidates[0].variant : null;
  }

  function announce(changes) {
    if (!changes.length) {
      return;
    }

    var status = document.getElementById(STATUS_ID);

    if (!status) {
      status = document.createElement('p');
      status.id = STATUS_ID;
      status.className = 'visually-hidden';
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      document.body.appendChild(status);
    }

    status.textContent = '';

    if (announcementFrame) {
      window.cancelAnimationFrame(announcementFrame);
    }

    announcementFrame = window.requestAnimationFrame(function () {
      status.textContent = 'Auswahl angepasst: ' + changes.join(', ') + '.';
    });
  }

  function rememberFocus(picker, control, value) {
    if (document.activeElement !== control) {
      return;
    }

    var formId = picker.getAttribute('form-id');

    if (!formId) {
      return;
    }

    focusSequence += 1;

    var entry = {
      sequence: focusSequence,
      originalControl: control,
      position: parseInt(control.getAttribute('data-option-position'), 10) - 1,
      value: value
    };

    pendingFocus[formId] = entry;

    window.setTimeout(function () {
      if (pendingFocus[formId] && pendingFocus[formId].sequence === entry.sequence) {
        delete pendingFocus[formId];
      }
    }, 10000);
  }

  function restorePendingFocus() {
    Object.keys(pendingFocus).forEach(function (formId) {
      var entry = pendingFocus[formId];

      if (entry.originalControl.isConnected) {
        return;
      }

      var pickers = document.querySelectorAll('variant-picker[form-id]');
      var picker = null;

      Array.prototype.some.call(pickers, function (candidate) {
        if (candidate.getAttribute('form-id') === formId) {
          picker = candidate;
          return true;
        }

        return false;
      });

      if (!picker) {
        return;
      }

      var match = findControl(picker, entry.position, entry.value);

      if (!match) {
        return;
      }

      try {
        match.control.focus({ preventScroll: true });
      } catch (error) {
        match.control.focus();
      }

      delete pendingFocus[formId];
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;

    if (!target || !target.matches || !target.matches(CONTROL_SELECTOR)) {
      return;
    }

    var picker = target.closest('variant-picker');

    if (!picker) {
      return;
    }

    var data = readGuideData(picker);

    if (!data) {
      return;
    }

    var currentValues = selectedValues(picker);
    var clickedPosition = parseInt(target.getAttribute('data-option-position'), 10) - 1;
    var clickedValue = controlText(target);

    rememberFocus(picker, target, clickedValue);

    if (data.variants.some(function (variant) {
      return variant.available !== false && isExactVariant(variant, currentValues);
    })) {
      return;
    }

    var selectedVariant = selectBestVariant(data.variants, currentValues, clickedPosition, clickedValue);

    if (!selectedVariant) {
      return;
    }

    var changes = [];

    selectedVariant.options.forEach(function (value, optionIndex) {
      if (optionIndex === clickedPosition || normalize(value) === normalize(currentValues[optionIndex])) {
        return;
      }

      if (applyValue(picker, optionIndex, value)) {
        var optionName = data.optionNames && data.optionNames[optionIndex] ? data.optionNames[optionIndex] : 'Option ' + (optionIndex + 1);
        changes.push(normalize(optionName) + ' ' + normalize(value));
      }
    });

    announce(changes);
  }, true);

  new MutationObserver(function () {
    restorePendingFocus();
    updateAllVariantStates();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  updateAllVariantStates();

  window.RapiusVariantGuide = {
    version: '1.2.0'
  };
})();
(function () {
  if (window.RapiusNumericOptionSorter) {
    return;
  }

  var CONTROL_SELECTOR = '.product-form__single-selector[data-option-position]';
  var DATA_SELECTOR = 'script[data-rapius-variant-guide]';
  var NUMERIC_OPTION_KINDS = {
    durchmesser: 'dimension',
    'länge': 'dimension',
    laenge: 'dimension',
    packungsmenge: 'quantity'
  };
  var DIMENSION_MULTIPLIERS = {
    'µm': 0.001,
    'μm': 0.001,
    mm: 1,
    cm: 10,
    dm: 100,
    m: 1000,
    zoll: 25.4,
    inch: 25.4,
    '″': 25.4,
    '"': 25.4
  };

  function normalize(value) {
    return String(value == null ? '' : value).trim().replace(/\s+/g, ' ');
  }

  function controlText(control) {
    if (control.tagName === 'SELECT') {
      var selectedOption = control.options[control.selectedIndex];
      return normalize(selectedOption ? selectedOption.textContent : '');
    }

    var label = control.labels && control.labels[0];
    return normalize(label ? label.textContent : '');
  }

  function numericOptionKind(optionName) {
    var normalizedName = normalize(optionName).toLowerCase();
    return Object.prototype.hasOwnProperty.call(NUMERIC_OPTION_KINDS, normalizedName)
      ? NUMERIC_OPTION_KINDS[normalizedName]
      : null;
  }

  function localizedNumber(numberText) {
    var token = numberText.replace(/\s+/g, '');
    var commaIndex = token.lastIndexOf(',');
    var dotIndex = token.lastIndexOf('.');

    if (commaIndex >= 0 && dotIndex >= 0) {
      var decimalSeparator = commaIndex > dotIndex ? ',' : '.';
      var decimalIndex = token.lastIndexOf(decimalSeparator);
      token =
        token.slice(0, decimalIndex).replace(/[.,]/g, '') +
        '.' +
        token.slice(decimalIndex + 1).replace(/[.,]/g, '');
    } else if (commaIndex >= 0) {
      token = token.replace(/\./g, '').replace(',', '.');
    } else if (/^-?\d{1,3}(?:\.\d{3})+$/.test(token)) {
      token = token.replace(/\./g, '');
    }

    var value = Number(token);
    return Number.isFinite(value) ? value : null;
  }

  function numericValue(text, optionKind) {
    var normalizedText = normalize(text).toLowerCase();
    var numberMatch = normalizedText.match(/-?\d[\d.,]*(?:\s+\d[\d.,]*)*/);

    if (!numberMatch) {
      return null;
    }

    var value = localizedNumber(numberMatch[0]);

    if (value === null || optionKind !== 'dimension') {
      return value;
    }

    var unitText = normalizedText
      .slice(numberMatch.index + numberMatch[0].length)
      .trim();
    var unitMatch = unitText.match(/^(µm|μm|mm|cm|dm|m|zoll|inch|″|")(?=\s|$|[.,;:])/);
    var multiplier = unitMatch ? DIMENSION_MULTIPLIERS[unitMatch[1]] : 1;
    return value * multiplier;
  }

  function sortNumericItems(items, textForItem, optionKind) {
    var numericEntries = [];
    var numericPositions = [];

    items.forEach(function (item, index) {
      var value = numericValue(textForItem(item), optionKind);

      if (value === null) {
        return;
      }

      numericPositions.push(index);
      numericEntries.push({
        item: item,
        originalIndex: index,
        value: value
      });
    });

    numericEntries.sort(function (left, right) {
      return left.value - right.value || left.originalIndex - right.originalIndex;
    });

    var sorted = items.slice();

    numericPositions.forEach(function (position, index) {
      sorted[position] = numericEntries[index].item;
    });

    return sorted;
  }

  function sortSelect(select, optionKind) {
    var selectedValue = select.value;
    var current = Array.prototype.slice.call(select.options);
    var sorted = sortNumericItems(current, function (option) {
      return option.textContent;
    }, optionKind);
    var changed = sorted.some(function (option, index) {
      return option !== current[index];
    });

    if (!changed) {
      return;
    }

    sorted.forEach(function (option) {
      select.appendChild(option);
    });

    select.value = selectedValue;
  }

  function sortSwatches(controls, optionKind) {
    var wrappers = [];

    Array.prototype.forEach.call(controls, function (control) {
      var wrapper = control.closest('.block-swatch, .variant-swatch, .color-swatch');

      if (wrapper && wrappers.indexOf(wrapper) === -1) {
        wrappers.push(wrapper);
      }
    });

    if (wrappers.length < 2) {
      return;
    }

    var parent = wrappers[0].parentNode;

    if (!parent || wrappers.some(function (wrapper) { return wrapper.parentNode !== parent; })) {
      return;
    }

    var controlByWrapper = new Map();

    Array.prototype.forEach.call(controls, function (control) {
      var wrapper = control.closest('.block-swatch, .variant-swatch, .color-swatch');

      if (wrapper) {
        controlByWrapper.set(wrapper, control);
      }
    });

    var sorted = sortNumericItems(wrappers, function (wrapper) {
      return controlText(controlByWrapper.get(wrapper));
    }, optionKind);
    var changed = sorted.some(function (wrapper, index) {
      return wrapper !== wrappers[index];
    });

    if (!changed) {
      return;
    }

    sorted.forEach(function (wrapper) {
      parent.appendChild(wrapper);
    });
  }

  function sortPicker(picker) {
    var script = picker.querySelector(DATA_SELECTOR);

    if (!script) {
      return;
    }

    var data;

    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      return;
    }

    if (!data || !Array.isArray(data.optionNames)) {
      return;
    }

    data.optionNames.forEach(function (optionName, optionIndex) {
      var optionKind = numericOptionKind(optionName);

      if (!optionKind) {
        return;
      }

      var controls = picker.querySelectorAll(CONTROL_SELECTOR + '[data-option-position="' + (optionIndex + 1) + '"]');

      if (!controls.length) {
        return;
      }

      if (controls.length === 1 && controls[0].tagName === 'SELECT') {
        sortSelect(controls[0], optionKind);
      } else {
        sortSwatches(controls, optionKind);
      }
    });
  }

  function inspect(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) {
      return;
    }

    if (root.matches && root.matches('variant-picker')) {
      sortPicker(root);
    }

    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('variant-picker'), sortPicker);
    }
  }

  inspect(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, inspect);
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.RapiusNumericOptionSorter = {
    version: '1.1.0'
  };
})();
